import { Box, Typography, Stack, IconButton, Avatar } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

export default function BookingCard({ booking, onEdit, onDelete }) {
  return (
    <Box
      sx={{
        p: 3,
        borderRadius: 4,
        bgcolor: "#fff",
        boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Avatar sx={{ bgcolor: "#DBEAFE", color: "#2563EB" }}>
          <AccessTimeIcon />
        </Avatar>

        <Box flex={1}>
          <Typography fontWeight={800}>{booking.label}</Typography>
        </Box>

        <IconButton onClick={onEdit}>
          <EditIcon />
        </IconButton>

        <IconButton onClick={onDelete} color="error">
          <DeleteIcon />
        </IconButton>
      </Stack>
    </Box>
  );
}
